import { render } from "./BirthdayIcon.vue?vue&type=template&id=67c39045"
const script = {}

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__